export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 9.15234C3 8.60006 3.44772 8.15234 4 8.15234H20C20.5523 8.15234 21 8.60006 21 9.15234V10.8956C19.6505 10.8956 18.3 11.8097 18.3 13.4098C18.3 15.01 19.6505 16.3821 21 16.3821V18.1254C21 18.6776 20.5523 19.1254 20 19.1254H4C3.44772 19.1254 3 18.6776 3 18.1254V16.3821C4.35051 16.3821 5.7 15.468 5.7 13.6388C5.7 11.8097 4.34949 10.8956 3 10.8956V9.15234ZM8 12.1997C8 11.7579 8.35817 11.3997 8.8 11.3997H11.2C11.6418 11.3997 12 11.7579 12 12.1997C12 12.6415 11.6418 12.9997 11.2 12.9997H8.8C8.35817 12.9997 8 12.6415 8 12.1997ZM8.8 14.3997C8.35817 14.3997 8 14.7579 8 15.1997C8 15.6415 8.35817 15.9997 8.8 15.9997L15.2 15.9997C15.6418 15.9997 16 15.6415 16 15.1997C16 14.7579 15.6418 14.3997 15.2 14.3997L8.8 14.3997Z"
                fill="#7C1D1D"
            />
            <path d="M7 7.5L15.541 3.9038C16.0644 3.68343 16.666 3.94259 16.8654 4.47431L18 7.5H7Z" fill="#7C1D1D" />
        </svg>
    );
}
